/**
 * Custom log function.
 *
 * @param {String} context Message.
 * @param {Mixed} data Data to log.
 */
export default (context, data) => {
	console.log(`\n %c ${context}`, `background: #bada55; color: #222; padding: 10px;`);
	console.log(data);
	console.log(`\n`);
};
